import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertsService } from '../../services/alerts.service';
import { LoaderService } from '../../services/loader.service';
import { UtilService } from '../../services/util.service';
import { BaseService } from '../../shared/services/base.service';
import { DialogConfig } from '../dialog/dialog-config';
import { DialogRef, DialogModalSize } from '../dialog/dialog-ref';
import { DialogService } from '../dialog/dialog.service';
import { AppService } from '../../shared/services/app.service';
import { TemplateInterceptorComponent } from '../template-interceptor/template-interceptor.component';

@Component({
    selector: 'app-popup-editable-grid-with-banner',
    templateUrl: './popup-editable-grid-with-banner.component.html',
    styleUrls: ['./popup-editable-grid-with-banner.component.scss'],
    standalone: false
})
export class PopupEditableGridWithBannerComponent implements OnInit {
  fields: any;
  config: any;
  btn = {
    "Add": [{
      "label": "button.submit",
      "icon": "fa fa-check"
    }]
  };
  currentData: any;
  resourceDef: any;
  decorator: any;
  constructor(
    public dialogConfig: DialogConfig,
    public dialog: DialogRef,
    public injector: Injector,
    public router: Router,
    public route: ActivatedRoute,
    public baseService: BaseService,
    public utilService: UtilService,
    public loader: LoaderService,
    public alerts: AlertsService,
    public dialogService: DialogService,
    public appService: AppService
  ) { }
  ngOnInit() {
    console.log("Route ", this.router);
    this.config = {
      "submitButton": true,
      "cancelButton": true,
      "filterForm": false,
      "clearOnSave": false,
      "delegateSave": true,
      "cancelRoute": ''
    }
    this['data'] = this.dialogConfig.data;
    this.fields = this['data'];
    if (this['data'] == undefined) {
      this.baseService.getResourceDef(this.route.snapshot.data.resource, (resourceDef) => {
        if (resourceDef) {
          this.resourceDef = resourceDef;
          this.baseService.setTitle(resourceDef.page_name.list);
          console.log('resource defination -------------->', resourceDef);
          this.baseService.getReferredField(resourceDef.form, (response) => {
            this.fields = {}
            this.fields['blocks'] = response;
            this.currentData = JSON.parse(sessionStorage.getItem('currentData'));
            if(this.resourceDef.config && this.resourceDef.config.decorator)
            this.decorator = this.baseService.initDecorator(this.resourceDef.config.decorator, this.route, this.injector);
          });
        }
      })
    }
  }

  listResource() {
    this.router.navigateByUrl(this.route.snapshot.queryParams.returnUrl);
  }

  onSaveFinished(event) {
    if (this['data'] == undefined) {
      delete event.result.id;
      delete event.result.g_creation_time;
      var resource = '';
      var application = '';
      var action = '';
      if (this.resourceDef.form.APIresource && this.resourceDef.form.APIresource != undefined && this.resourceDef.form.APIresource.datasource != undefined) {
        console.log("API Resource", this.resourceDef.form.APIresource)
        resource = this.resourceDef.form.APIresource.datasource['resource'];
        application = this.resourceDef.form.APIresource.datasource['application'];
        if (this.resourceDef.form.APIresource.datasource.action != undefined) {
          action = this.resourceDef.form.APIresource.datasource.action;
        } else {
          action = 'ADD';
        }
      } else {
        resource = this.resourceDef.resource;
        application = '';
        action = 'ADD';
      }
      if (event && event.currentBtnVal && event.currentBtnVal.datasource != undefined && event.currentBtnVal.datasource.action != undefined) {
        action = event.currentBtnVal.datasource.action
      }
      let templateInterceptor = (event && event.currentBtnVal && event.currentBtnVal.templateInterceptor) ? event.currentBtnVal.templateInterceptor : (this.resourceDef.form.APIresource ? this.resourceDef.form.APIresource.templateInterceptor : undefined);
      const proceed = () => {
        this.loader.showSpinner();
        this.baseService.action(event.result, action, application, resource).subscribe(
          (data: any) => {
            if (data.errCode == -1) {
              this.alerts.error(data.message);
            } else {
              this.alerts.success("Added Successfully");
              this.listResource();
            }
            this.loader.hideSpinner();
          }, error => {
            console.log(error);
            this.alerts.error('API error');
            this.loader.hideSpinner();
          }
        )
      };
      if (templateInterceptor) {
        this.checkTemplates(event.result, { templateInterceptor }, proceed);
      } else {
        proceed();
      }
    } else {
      this.dialog.close(event);
    }
  }
  //checks if a clinical-consent template is configured for this action's next_stage before letting it proceed
  checkTemplates(data_, action, proceed: () => void) {
    try {
      this.loader.showSpinner();
      let datasource = action.templateInterceptor.datasource;
      let primary = Object.assign({}, data_);
      primary['next_stage'] = action.templateInterceptor.next_stage;
      if (primary != undefined && !primary.care_type) {
        try { primary['care_type'] = this.appService.getDynamicFunctions("getCurrentCareType"); } catch (error) { }
      }
      if (primary != undefined && primary.patient_gender) {
        primary['patient_gender'] = (primary.patient_gender + '').toLowerCase();
      }
      let args = this.baseService.buildDyanamicStr(datasource.args, { data: primary });
      this.baseService.get(datasource.query_id, args, datasource.resource, datasource.application, datasource.filter).subscribe(data => {
        if (data && data.errCode != -1 && data.resource != undefined && data.resource.length != undefined && data.resource.length > 0) {
          this.openTemplIntersep(primary, { templateInterceptor: action.templateInterceptor }, false, (res) => {
            if (res) { proceed(); }
          });
        } else {
          this.loader.hideSpinner();
          proceed();
        }
      }, (error) => {
        this.loader.hideSpinner();
        proceed();
      });
    } catch (error) {
      this.loader.hideSpinner();
      proceed();
    }
  }
  openTemplIntersep(data: any, actionType, config?, callback?) {
    let popobj = { data: { action: actionType, data: data }, title: 'Template', size: DialogModalSize.Lg };
    if (config) popobj.data['config'] = config;
    this.dialogService.open(TemplateInterceptorComponent, popobj).afterClosed.subscribe(res => {
      if (res) callback(true);
    });
  }
}
